import React from "react";
import { MdOutlineElectricBolt, MdOutlineQueryStats} from "react-icons/md";
import { IoInformationCircleOutline } from "react-icons/io5";

const Tariff = () => {
  return (
    <div className="w-full min-h-screen bg-white text-slate-800 font-sans">
      {/* HERO SECTION */}
      <div className="relative bg-[#14532d] text-white py-8 md:py-10 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            backgroundSize: '60px 60px'
          }}></div>
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 relative z-10">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold leading-tight uppercase tracking-tight">
            Tariff Class <span className="text-yellow-400">and Availability</span>
          </h2>
          <div className="w-20 h-1.5 bg-yellow-400 rounded-full mt-4"></div>
          <p className="mt-4 text-white opacity-90 max-w-2xl text-sm sm:text-base md:text-lg font-normal">
            Stay informed about your energy costs. View the latest service-based
            tariff (SBT) rates and check your supply band.
          </p>
        </div>
      </div>

      {/* CENTERED IMAGE SECTION */}
      <section className="w-full bg-white py-8 md:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 flex flex-col items-center">
          <div className="relative rounded-2xl md:rounded-3xl overflow-hidden shadow-xl border-4 md:border-8 border-white ring-1 ring-gray-100">
            <img
              src="/images/Know-your-Tariff.png"
              alt="BEDC Tariff Info"
              className="w-full h-auto object-cover"
            />
          </div>
        </div>
      </section>

      {/* LOOKUP & CALCULATOR CTA */}
      <section className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 pb-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Lookup Card */}
          <div className="bg-black rounded-3xl p-8 md:p-10 text-white flex flex-col items-start shadow-xl relative overflow-hidden group">
            <div className="absolute top-0 right-0 w-64 h-64 bg-green-700/20 rounded-full -mr-32 -mt-32 group-hover:scale-110 transition-transform duration-700"></div>
            <div className="w-12 h-12 bg-green-700 text-white rounded-xl flex items-center justify-center mb-6 shadow-lg">
              <MdOutlineQueryStats size={26} />
            </div>
            <h4 className="text-xl md:text-2xl font-bold mb-3 uppercase tracking-tight">Don't know your band?</h4>
            <p className="text-gray-400 text-sm md:text-base mb-8">Enter your meter or account number to instantly find out your service band and applicable tariff.</p>
            <a href="/customer-feeder-info" className="w-full">
              <button className="w-full bg-yellow-400 text-black py-4 rounded-xl font-bold uppercase tracking-wider text-xs hover:bg-green-700 hover:text-white transition-all shadow-lg">
                Check Meter Band →
              </button>
            </a>
          </div>

          <div className="bg-green-700 rounded-3xl p-8 md:p-10 text-white flex flex-col items-start shadow-xl relative overflow-hidden group">
            <div className="absolute top-0 right-0 w-64 h-64 bg-black/20 rounded-full -mr-32 -mt-32 group-hover:scale-110 transition-transform duration-700"></div>
            <div className="w-12 h-12 bg-black text-yellow-400 rounded-xl flex items-center justify-center mb-6 shadow-lg">
              <MdOutlineElectricBolt size={26} />
            </div>
            <h4 className="text-xl md:text-2xl font-bold mb-3 uppercase tracking-tight">Latest Tariff Order</h4>
            <p className="text-green-50 text-sm md:text-base mb-8">Download the latest NERC approved tariff schedule for all customer categories.</p>
            <a
              href="/images/Know-your-Tariff.png"
              download="Tariff-Image.jpg"
              className="w-full"
            >
              <button className="w-full bg-white text-green-700 py-4 rounded-xl font-bold uppercase tracking-wider text-xs hover:bg-black hover:text-white transition-all shadow-lg">
                Download Image ↓
              </button>
            </a>
          </div>
        </div>
      </section>

      {/* DISCLAIMER */}
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-8 pb-20">
        <div className="flex items-start gap-4 p-8 bg-gray-50 rounded-[2rem] border border-gray-100 text-gray-500 font-medium italic text-sm leading-relaxed">
          <IoInformationCircleOutline className="text-green-700 text-2xl flex-shrink-0" />
          <p>
            Rates are subject to change based on NERC (Nigerian Electricity Regulatory Commission) guidelines.
            The actual units received may be affected by outstanding debts or fixed charges applicable to your account.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Tariff;